import { render, staticRenderFns } from "./DocumentsCompanyDetail.vue?vue&type=template&id=4d4c846e&scoped=true"
import script from "./DocumentsCompanyDetail.vue?vue&type=script&lang=js"
export * from "./DocumentsCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCompanyDetail.vue?vue&type=style&index=0&id=4d4c846e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c846e",
  null
  
)

export default component.exports